import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button, Drawer, Form, Icon, message, Modal, Select, Spin, Switch } from "antd";

import { API_ERRO_TYPE_VALIDATION } from "./../../../config/general";

import { FORM_VALIDATION_MESSAGES } from "./../../../config/lang";

import { weedService, webserviceService } from "./../../../redux/services";

const FormItem = Form.Item;

class Edit extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading           : true,
			isSending           : false,
			owner_id            : 0,
			id                  : 0,
			recommendationsItems: {
				defensive      : [],
				fertilizer     : [],
				leaf_fertilizer: [],
			},
			recommendationsTypes: [
				{
					id  : "defensive",
					name: "Defensivos",
				},
				{
					id  : "fertilizer",
					name: "Fertilizantes/Corretivos",
				},
				{
					id  : "leaf_fertilizer",
					name: "Fertilizantes foliares",
				},
			],
			typeSelected        : null,
		};
	}

	fieldOptions = {
		recommendation_type: {
			label    : "Tipo",
			decorator: {
				rules: [
					{required: true, message: "Campo obrigatório."},
				],
			},
		},
		recommendation_id  : {
			label    : "Produto",
			decorator: {
				rules: [
					{required: true, message: "Campo obrigatório."},
				],
			},
		},
		is_highlighted     : {
			label    : "Recomendação AgroApp",
			decorator: {
				valuePropName: "checked",
			},
		},
	};

	onOpen = (owner_id, id) => {
		this.setState({
			isLoading: true,
			owner_id : owner_id,
			id       : id,
		});

		let item = {};

		weedService.showRecommendation({
			owner_id,
			id,
		})
		.then((response) => {
			item = response.data.data;

			return webserviceService.getRecommendationsItems();
		})
		.then((response) => {
			this.setState({
				isLoading           : false,
				item                : item,
				recommendationsItems: response.data.data,
				typeSelected        : item.recommendation_type,
			});

			// Fill form
			this.fillForm(item);
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	fillForm = (data) => {
		this.props.form.setFieldsValue({
			recommendation_type: data.recommendation_type,
			recommendation_id  : data.recommendation_id,
			is_highlighted     : data.is_highlighted,
		});
	};

	resetFields = () => {
		this.props.form.resetFields();

		this.setState({
			recommendationsItems: {
				defensive      : [],
				fertilizer     : [],
				leaf_fertilizer: [],
			},
			typeSelected        : null,
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onSubmit = (e) => {
		e.preventDefault();

		this.props.form.validateFieldsAndScroll((error, values) => {
			if( !error )
			{
				this.setState({
					isSending: true,
				});

				const {owner_id, id} = this.state;

				// Owner ID
				values.owner_id = owner_id;

				// ID
				values.id = id;

				weedService.editRecommendation(values)
				.then((response) => {
					this.setState({
						isSending: false,
					});

					// Reset fields
					this.resetFields();

					// Success message
					message.success("Registro atualizado com sucesso.");

					// Callback
					this.props.onComplete();
				})
				.catch((data) => {
					this.setState({
						isSending: false,
					});

					// if validation error
					if( data.error_type === API_ERRO_TYPE_VALIDATION )
					{
						let hasFieldsErrors = false;

						for( let key in data.error_errors )
						{
							if( data.error_errors[key] && this.fieldOptions[key] )
							{
								this.props.form.setFields({
									[key]: {
										value : values[key],
										errors: [new Error(data.error_errors[key])],
									}
								});

								hasFieldsErrors = true;
							}
						}

						if( !hasFieldsErrors )
						{
							Modal.error({
								title  : "Ocorreu um erro!",
								content: data.error_message,
							});
						}
					}
					else
					{
						Modal.error({
							title  : "Ocorreu um erro!",
							content: data.error_message,
						});
					}
				});
			}
		});
	};

	render() {
		const {visible, form}                                                                      = this.props;
		const {id, isLoading, isSending, recommendationsItems, recommendationsTypes, typeSelected} = this.state;

		const {getFieldDecorator} = form;

		return (
			<Drawer
				visible={visible}
				className="drawer-form"
				width={500}
				maskClosable={false}
				closable={false}
				keyboard={false}
				placement="right"
				onClose={this.onClose}>
				<Form layout="vertical" onSubmit={this.onSubmit}>
					<div className="form-header">
						<Button className="btn-close" onClick={this.onClose} icon="close" disabled={isLoading || isSending} />
						<div className="ant-drawer-title">{`Editar registro [${id}]`}</div>
						<Button type="primary" onClick={this.onSubmit} className="btn-save" icon="check" loading={isSending} disabled={isLoading}>Salvar</Button>
					</div>
					{isLoading ? (
						<div className="text-center" style={{padding: 20}}>
							<Spin indicator={<Icon type="loading" style={{fontSize: 60}} spin />} />
						</div>
					) : (
						<div className="form-body">
							<FormItem label={this.fieldOptions.recommendation_type.label} hasFeedback>
								{getFieldDecorator("recommendation_type", this.fieldOptions.recommendation_type.decorator)(
									<Select
										filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										allowClear
										onChange={(value) => {
											this.setState({typeSelected: value ? value : null}, () => {
												form.resetFields(["recommendation_id"]);
											})
										}}
										showSearch>
										{recommendationsTypes.map((item, index) => (
											<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
										))}
									</Select>
								)}
							</FormItem>
							<FormItem label={this.fieldOptions.recommendation_id.label} hasFeedback>
								{getFieldDecorator("recommendation_id", this.fieldOptions.recommendation_id.decorator)(
									<Select
										filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										allowClear
										disabled={typeSelected === null}
										placeholder={typeSelected === null ? "Primeiro selecione o tipo desejado" : ""}
										showSearch>
										{typeSelected && recommendationsItems[typeSelected].map((item, index) => (
											<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
										))}
									</Select>
								)}
							</FormItem>
							<FormItem label={this.fieldOptions.is_highlighted.label}>
								{getFieldDecorator("is_highlighted", this.fieldOptions.is_highlighted.decorator)(
									<Switch />
								)}
							</FormItem>
						</div>
					)}
				</Form>
			</Drawer>
		)
	}
}

export default Form.create({
	validateMessages: FORM_VALIDATION_MESSAGES,
})(Edit);
